import { v4 as uuidv4 } from "uuid";

export class DelProjectUnit {
  constructor(data = {}) {
    this.rowId = data.id || uuidv4();
    this.unitNumber = data.unit_number || null;
    this.unitName = data.unit_number
      ? data.unit_number + " - " + data.unit_name
      : data.unit_name || null;
    this.quantity = data.quantity || null;
    this.unitTableName = data.unit_table_name || null;
    this.unitType = data.unit_type || null;
    this.singularLabel = data.singular_label || null;
    this.pluralLabel = data.plural_label || null;
  }

  updateUnitSelection(
    unitNumber,
    unitName,
    unitTableName,
    unitType,
    singularLabel,
    pluralLabel,
  ) {
    this.unitNumber = unitNumber;
    this.unitName = unitName;
    this.unitTableName = unitTableName;
    this.unitType = unitType;
    this.singularLabel = singularLabel;
    this.pluralLabel = pluralLabel;
  }

  updateQuantity(quantity) {
    this.quantity = quantity;
  }

  toJson() {
    return {
      id: this.rowId,
      unit_number: this.unitNumber,
      quantity: this.quantity,
      unit_table_name: this.unitTableName,
    };
  }

  toPatch(action, fields) {
    const fieldMap = {
      unitNumber: "unit_number",
      quantity: "quantity",
      unitTableName: "unit_table_name",
    };
    const patch = {
      patch_type: "project_specific_unit",
      action: action,
      id: this.rowId,
    };
    for (const [key, value] of Object.entries(fields)) {
      const dbField = fieldMap[key];
      if (dbField) {
        patch[dbField] = value;
      }
    }
    return patch;
  }
}
